import React, { useState, useEffect } from 'react';
import SignupForm from '../components/Auth/SignupForm';

const SignupPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ 
      minHeight: '98vh',
      backgroundImage: 'URL(https://i.ibb.co/prQLTrZp/8e9b3778-ed98-4448-9a28-6f581bf79ada-1-50.jpg)',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    }}>
      
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        padding: isMobile ? '50px 15px 0px 15px' : '100px 30px 0px 30px'
      }}>
        <div style={{ 
          backgroundColor: '#ffd700', 
          padding: isMobile ? '8px 15px' : '10px 20px', 
          borderRadius: '5px',
          marginBottom: '20px'
        }}>
          <h1 style={{ 
            color: 'white', 
            margin: 0, 
            fontSize: isMobile ? '20px' : '24px' 
          }}>STYLE</h1>
        </div>
        <p style={{ 
          marginBottom: '20px', 
          color: '#666',
          fontSize: isMobile ? '14px' : '16px',
          textAlign: 'center'
        }}>
          素敵な出会いにSTYLEVS
        </p>
        
        <div style={{
          backgroundColor: '#ebe0e0ff',
          padding: isMobile ? '20px' : '15px',
          borderRadius: '10px',
          boxShadow: '0 10px 10px rgba(7, 0, 0, 0.34)',
          maxWidth: isMobile ? '95%' : '375px',
          width:'100%'
        }}>
          <SignupForm />
        </div>
        <div style={{
          width:'100%', 
          marginTop: isMobile ? '50px' : '100px'
        }}>
          <div style={{
            width: isMobile ? '100px' : '150px',
            height: isMobile ? '100px' : '150px',
            float:'right',
            backgroundImage: 'URL(https://i.ibb.co/WNyJmHZT/8.png)',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
          }}> </div>
        </div>
      </div>
    </div>
  );
};

export default SignupPage; 